import { createBrowserRouter } from 'react-router';
import AppLayout from '@/layouts/AppLayout';
import DashboardPage from '@/pages/DashboardPage';
import CompaniesPage from '@/pages/CompaniesPage';
import CreateCompanyPage from '@/pages/CreateCompanyPage';
import { CompanyTaxesPage } from '@/pages/CompanyTaxesPage';
import CompanyInformationPage from '@/pages/CompanyInformationPage';
import RootUsersPage from '@/pages/RootUsersPage';
import LoginPage from '@/pages/LoginPage';
import { requireAuth } from '@/auth/session';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    id: 'protected',
    path: '/',
    element: <AppLayout />,
    loader: requireAuth,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'companies', element: <CompaniesPage /> },
      { path: 'companies/new', element: <CreateCompanyPage /> },
      { path: 'company-taxes', element: <CompanyTaxesPage /> },
      { path: 'company-information', element: <CompanyInformationPage /> },
      { path: 'users', element: <RootUsersPage /> },
    ],
  },
]);
